import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Tag } from "antd";
import HeadingBack from "./common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SvgIcon from "./const/SvgIcon";
import { allApiAction } from "../Redux/common/action";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { toast } from "react-toastify";
import moment from "moment";

function Orders() {
  const { confirm } = Modal;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [orderDetails, setOrderDetails] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDelelt, setShowDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { order_list } = useSelector((state) => ({
    order_list: state?.allApi?.order_list || {},
  }));

  const listData = order_list?.data || [];

  useEffect(() => {
    dispatch(
      allApiAction.getOrders({
        page: page,
        search: search,
      })
    );
  }, [page, search, dispatch]);

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handlePageChange = (currentPage) => {
    setPage(currentPage);
  };

  const columns = [
    // Serial Number
    {
      title: "S.No.",
      key: "serial",
      width: 80,
      render: (_, __, index) => {
        return (
          (page - 1) * (order_list?.per_page || 10) +
          index +
          1
        );
      },
    },

    // Order ID
    {
      title: "Order ID",
      dataIndex: "id",
      key: "id",
      width: 100,
      render: (value) => value || "-",
    },

    // User ID
    {
      title: "User ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 100,
      render: (value) => value || "-",
    },

    // User Name
    {
      title: "User Name",
      dataIndex: "user",
      key: "user_name",
      render: (user) => user?.name || "-",
    },

    // User Email
    {
      title: "Email",
      dataIndex: "user",
      key: "user_email",
      render: (user) => user?.email || "-",
    },

    // User Mobile
    {
      title: "Mobile",
      dataIndex: "user",
      key: "user_mobile",
      render: (user) => user?.mobile || "-",
    },

    // Occasion
    {
      title: "Occasion",
      dataIndex: "occasion",
      key: "occasion",
      render: (occasion) => occasion?.title || "-",
    },

    // Total Amount
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      key: "total_amount",
      render: (value) => value ?? "-",
    },
    // Discount
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (value) => value ?? 0,
    },

    // Final Amount
    {
      title: "Final Amount",
      dataIndex: "final_amount",
      key: "final_amount",
      render: (value) => value ?? "-",
    },
    // Payment Status
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      render: (value) => {
        const status = value || "pending";

        return (
          <Tag
            color={
              status === "paid"
                ? "green"
                : status === "failed"
                ? "red"
                : "orange"
            }
          >
            {status.toUpperCase()}
          </Tag>
        );
      },
    },

    // Order Date
    {
      title: "Order Date",
      dataIndex: "date",
      key: "date",
      render: (date) =>
        date ? moment(date).format("DD-MM-YYYY") : "-",
    },

    // Created At
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) =>
        date
          ? moment(date).format("DD-MM-YYYY hh:mm a")
          : "-",
    },

    // Actions
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item) => {
        return (
          <>
            <Tooltip title="View Detail">
              <span
                className="cursor-pointer"
                onClick={() => {
                  viewDetails(item);
                }}
              >
                <SvgIcon.Visibility className="scale-icon edit-icon" />
              </span>
            </Tooltip>

            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?.id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleDelete = async (id) => {
    setShowDelete(false);

    await dispatch(
      allApiAction.deleteOrder({
        order_id: id,
        page: page,
      })
    );

    dispatch(
      allApiAction.getOrders({
        page: page,
        search: search,
      })
    );
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure delete?",
      icon: <ExclamationCircleFilled />,
      content: "Order",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",

      onOk() {
        handleDelete(id);
      },

      onCancel() {},
    });
  };

  const viewDetails = (order) => {
    navigate(`${order.id}`);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const files = event.target.files;
      setSelectedFile(files);
    }
  };

  const handleAddTextChange = (event) => {
    const { name, value } = event.target;

    setOrderDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const showModalAdd = (e) => {
    setOrderDetails(e || {});
    setIsModalOpen(true);
  };

  const handleCancelAdd = () => {
    setIsModalOpen(false);
    setOrderDetails({});
    setSelectedFile(null);
  };

  const handleOk = async () => {
    if (!orderDetails?.title) {
      toast.error("Please enter a title");
      return;
    }

    if (!selectedFile && !orderDetails?.id) {
      toast.error("Please select image");
      return;
    }

    const data = new FormData();

    data.append("title", orderDetails?.title);

    if (selectedFile) {
      for (let i = 0; i < selectedFile.length; i++) {
        data.append("image", selectedFile[i]);
      }
    }

    try {
      if (orderDetails?.id) {
        data.append("id", orderDetails?.id);

        await dispatch(allApiAction.updateOrder(data));
      }

      dispatch(
        allApiAction.getOrders({
          page: page,
          search: search,
        })
      );

      setIsModalOpen(false);
      setOrderDetails({});
      setSelectedFile(null);
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error updating order");
    }
  };

  return (
    <div>
      {/* Header Bar */}
      <div className="flex">
        <div>
          <HeadingBack
            title="Order"
            subHeading={`Total ${order_list?.total || 0} Order`}
          />
        </div>

        {/* Search bar currently hidden */}
        {/*
        <Col md={5} sm={5} xs={12} className="ml-5 pl-5">
          <Input
            type="text"
            autoComplete="off"
            className="form-control"
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search by user, email, mobile, order..."
            value={search}
          />
        </Col>
        */}
      </div>

      {/* Orders Table */}
      <div className="tableResponsive mt-10">
        <Table
          rowKey="id"
          dataSource={listData}
          columns={columns}
          className="table antd_table"
          scroll={{ x: 1600 }}
          pagination={{
            current: page,
            pageSize: order_list?.per_page || 10,
            total: order_list?.total || 0,

            onChange: (currentPage) => {
              handlePageChange(currentPage);
            },

            hideOnSinglePage: true,
          }}
        />
      </div>

      {/* Add/Edit Modal */}
      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title="Create Order"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancelAdd}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="off"
            className="form-control"
            placeholder="Title"
            name="title"
            value={orderDetails?.title || ""}
            onChange={handleAddTextChange}
          />
        </Col>

        <Col
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="mt-10"
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </Col>
      </Modal>
    </div>
  );
}

export default Orders;
